import { MetaEntry } from '../../lib/types'
import React, { useState } from 'react'
import HTMLReactParser from 'html-react-parser'

type Props = {
    meta: MetaEntry
}

const urlify = (text: string) => {
    const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi
    return (
        '<div>' +
        text.replace(urlRegex, (url) => {
            return `<a href="${url}" target="_blank">${url}</a>`
        }) +
        '</div>'
    )
}

export default function NoteIndicator(props: Props) {
    const { meta } = props
    let [hovering, setHovering] = useState(false)

    if (!meta.notes) return null

    return (
        <div
            className='note-indicator'
            onMouseEnter={() => {
                setHovering(true)
            }}
        >
            <i className='lni lni-comments' />

            {hovering && (
                <div
                    className='note-popup'
                    onClick={(e) => {
                        e.stopPropagation()
                    }}
                    onMouseLeave={() => {
                        setHovering(false)
                    }}
                >
                    {HTMLReactParser(urlify(meta.notes))}
                </div>
            )}
        </div>
    )
}
